import angular from 'angular';
import _ from 'lodash-es';
import 'angular-i18n/fr-fr';

const ConvertStatusClass = {
	TO_PROCESS: 'primary',
	PROCESSING: 'info',
	DONE:       'success',
	ERROR:      'danger',
};

export default class AdminKonvController {
	/* @ngInject */
	constructor($http, $interval, $scope, $timeout, $translate, $websocket, API, Notification, User) {
		this.$http = $http;
		this.$interval = $interval;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$websocket = $websocket;
		this.API = API;
		this.Notification = Notification;
		this.User = User;

		this.config = {};
		this.konvUrlApi = this.User.getConfig().KONV?.url_api;
		this.log = {};
		this.status = {
			class:       'danger',
			message:     'OFF',
			btnDisabled: true,
			todo_nb:     0,
			done_nb:     0,
		};
		this.trconfig = {};
		this.intervalInit = undefined;
		this.maxKey = 0;

		this.startCheck();

		$scope.$on('$destroy', () => {
			this.$interval.cancel(this.intervalInit);
			this.intervalInit = undefined;
		});

		this.init();
	}

	async fileKonvStatus() {
		const result = await this.serviceRequest({ action: 'FileKonvStatus' });
		this.status.done_nb = result.data.done_nb;
		this.status.todo_nb = result.data.todo_nb;
	}

	async fileKonvProcessStart() {
		const result = await this.serviceRequest({ action: 'FileKonvProcessStart' });
		console.log('res', result);
	}

	genLog(data) {
		if (data) {
			for (const [k, line] of Object.entries(data.lines)) {
				if (line) {
					const r = /^(\S+) - (\S+)? ?- \[([^:]+):(\d{2}:\d{2}:\d{2})] "(\S+) (.+)"$/.exec(line.trim());
					if (r) {
						const date = new Date(`${r[3]}Z`);
						if (!(date.toISOString() in this.log)) {
							this.log[date.toISOString()] = {
								date,
								lines: [],
							};
						}

						this.log[date.toISOString()].lines.unshift({
							key: Number.parseInt(k, 10), host: r[1], time: new Date(`${r[3]} ${r[4]}`), type: r[5], string: r[6],
						});
						// drawTrLog({key: parseInt(k), host: r[1], datetime: r[3], type: r[4], string: r[5]}, false);
						this.maxKey = Math.max(this.maxKey, Number.parseInt(k, 10));
					}
				}
			}
		}
	}

	getSummaryString(line) {
		let action = null;
		let response = 200;

		try {
			const objectJson = JSON.parse(line.string);
			({ action, response } = objectJson);
			if (!action) {
				// noinspection ExceptionCaughtLocallyJS
				throw new Error('no action');
			}
		}
		catch {
			const r = /^\/([a-z]+)/i.exec(line.string);
			action = r ? r[1] : line.string;
		}
		return action || (response === 200 ? 'OK' : 'Error');
	}

	async init() {
		try {
			const configResult = await this.serviceRequest({ action: 'ConfigGet' });
			this.config = configResult.data.config;
			this.$interval.cancel(this.intervalInit);
			this.intervalInit = undefined;

			for (const [ksection, section] of Object.entries(configResult.data.config)) {
				for (const [key, value] of Object.entries(section)) {
					this.trconfig[`${ksection}.${key}`] = value;
				}
			}

			let webSocketServer = 'ws://';
			if (window.location.protocol === 'https:') {
				webSocketServer = 'wss://';
			}
			webSocketServer += `${this.config.SocketServer.hostname}:${this.config.SocketServer.port}/ws`;

			if (this.config.Daemon.logfile) {
				const resultLog = await this.API.log(this.config.Daemon.logfile, 30);
				this.genLog(resultLog.data);
				this.launchSocket(webSocketServer);
			}

			const stackResult = await this.serviceRequest({ action: 'FileKonvGetStack' });
			this.stack = stackResult.data.stack;

			await this.fileKonvStatus();
		}
		catch {
			// console.error(`${this.konvUrlApi} Unable to etablish a connection to the service`);
			this.Notification.error({
				title: this.$translate.instant('error.title'),
				message: `${this.konvUrlApi} Unable to etablish a connection to the service`,
				replaceMessage: true,
			});
		}
	}

	// simple but fast
	isJSON(string) {
		return /{(.+)}/.test(string);
	}

	launchSocket(webSocketServer) {
		const ws = this.$websocket(webSocketServer);

		ws.onOpen(() => {
			this.status.class = 'success';
			this.status.message = 'ON';
			this.status.btnDisabled = false;
		});

		ws.onMessage(event_ => {
			const json = JSON.parse(event_.data);

			if ('log' in json) {
				_.merge(this.log, json.log);
			}
			else if ('stack' in json) {
				_.merge(this.stack, json.stack);
			}
			else if ('file' in json) {
				this.stack.map(f => {
					if (f.nodeid === json.file.nodeid) {
						_.merge(f, json.file);
					}
					return f;
				});
			}
		});

		ws.onClose(() => {
			this.status.class = 'danger';
			this.status.message = 'OFF';
			this.status.btnDisabled = true;
			this.startCheck();
		});

		ws.onError(error => {
			console.error(error);
			this.status.class = 'warning';
			this.status.message = 'ERROR';
		});
	}

	async serviceRequest(request) {
		return this.$http.get(
			this.konvUrlApi,
			{ params: { request: angular.toJson(request) } },
		);
	}

	startCheck() {
		if (this.intervalInit) {
			return;
		}
		this.intervalInit = this.$interval(() => this.init(), 5000);
	}
}
